import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=02473cd5&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=02473cd5&scoped=true&lang=css&"
import style1 from "./Projects.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02473cd5",
  null
  
)

export default component.exports